import React from "react";
export var QuickAddModalEvent;
(function(QuickAddModalEvent) {
    QuickAddModalEvent[QuickAddModalEvent["GO_TO_PRODUCT_PAGE"] = 0] = "GO_TO_PRODUCT_PAGE";
    QuickAddModalEvent[QuickAddModalEvent["CHANGE_QUANTITY"] = 1] = "CHANGE_QUANTITY";
    QuickAddModalEvent[QuickAddModalEvent["ADD_TO_CART"] = 2] = "ADD_TO_CART";
})(QuickAddModalEvent || (QuickAddModalEvent = {}));
export var QuickAddModalContext = React.createContext({});
